import ModuleOverviewInset from './container'
export default ModuleOverviewInset
